import {FORM_LOAD_DATA_FOR_DATASTRUCTURE} from '~/frontend/src/constants';
import {
    StoreState,
    AppDispatch,
    Thunk
} from '~/frontend/src/store';
import {
    ElusiveData,
    setElusiveData
} from '~/frontend/src/actions/elusiveData';
import dataLoadData from '~/frontend/src/actions/data/loadData';
import {
    LoadDataForDataStructureParameters,
    LoadDataForDataStructureResult
} from '~/shared/src/utilities/modules/form';
import {MergeMode} from '~/frontend/src/utilities/dataUtils';
import {DataStructure} from '~/shared/src/utilities/dataStructure';


/**
 * @memberOf! Actions
 *
 * @param {string} panelKey
 * @param {string} dataContext
 * @param {Schema} schema
 * @param {Status} status
 * @param {MergeMode} [mergeMode='override']
 * @param {DataStructure} dataStructure
 * @param {number} [rootItemId]
 * @param {string} [rootItemType]
 * @param {string} [rootItemKey]
 *
 * @return {Promise<LoadDataForDataStructureResult | false>}
 */
const loadDataForDataStructure = ( panelKey : string, dataContext : string, schema: Schema, status : Status, mergeMode : MergeMode = 'override', dataStructure : DataStructure, rootItemId? : number, rootItemType? : string, rootItemKey? : string ) : Thunk<Promise<LoadDataForDataStructureResult | false>> => async ( dispatch : AppDispatch, getState : () => StoreState ) : Promise<LoadDataForDataStructureResult | false> => {
    dispatch( {
        type: FORM_LOAD_DATA_FOR_DATASTRUCTURE,
        panelKey,
        dataContext,
        status,
        mergeMode,
        dataStructure,
        rootItemId,
        rootItemType,
        rootItemKey
    } );

    const elusiveData                  = getState().elusiveData?.[ panelKey ],
          newElusiveData : ElusiveData = {
              ...elusiveData
          };

    let retVal : LoadDataForDataStructureResult | false = false,
        params : LoadDataForDataStructureParameters | undefined;

    if ( rootItemType && rootItemKey ) {
        params = {
            status,
            dataStructure,
            rootItemType,
            rootItemKey
        }
    }
    else if ( rootItemId ) {
        params = {
            status,
            dataStructure,
            rootItemId
        };
    }

    delete newElusiveData.data;
    dispatch( setElusiveData( panelKey, newElusiveData ) );

    await dispatch( dataLoadData(
        'form/loadDataForDataStructure',
        dataContext,
        panelKey,
        'loadData',
        schema,
        {
            params,
            mergeMode
        },
        true,
        ( data ) => {
            retVal = data as LoadDataForDataStructureResult;
        }
    ) );

    return retVal;
}
export type LoadDataForDataStructure = typeof loadDataForDataStructure;

export default loadDataForDataStructure;
